export * from "./customer-complaint-tags";
export * from "./customer-profile-complains.component";
